'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var insurance = function insurance(friendlyName, desc, name) {
    _classCallCheck(this, insurance);

    this.desc = desc;
    this.name = name;
    this.friendlyName = friendlyName;
    this.imgSrc = "/images/insurance/imgs/" + name + '.svg';
    this.saved = false;
    this.show = false;
};

var cabin = function (_insurance) {
    _inherits(cabin, _insurance);

    function cabin() {
        _classCallCheck(this, cabin);

        var _this = _possibleConstructorReturn(this, (cabin.__proto__ || Object.getPrototypeOf(cabin)).call(this, 'Hytte/fritidsbolig', '', 'cabin'));

        _this.address = "";
        _this.usageArea = "";
        _this.usageAreaAdditional = [{
            id: _this.generateId(),
            area: ""
        }];
        _this.waterInstalled = false;
        _this.electricsInstalled = false;
        _this.requestedCoverage = "";
        _this.contentsCoverage = "";
        return _this;
    }

    _createClass(cabin, [{
        key: 'generateId',
        value: function generateId() {
            // generate random id
            return Math.random().toString(36).substring(2, 9);
        }
    }]);

    return cabin;
}(insurance);

var mc = function (_insurance2) {
    _inherits(mc, _insurance2);

    function mc() {
        _classCallCheck(this, mc);

        var _this2 = _possibleConstructorReturn(this, (mc.__proto__ || Object.getPrototypeOf(mc)).call(this, 'MC/Moped/ATV/ Snøscooter', '', 'mc'));

        _this2.regNumber = "";
        _this2.ownerOnlyDriver = "";
        _this2.coverage = "";
        _this2.ageOfYoungestDriver = "";
        return _this2;
    }

    return mc;
}(insurance);

var car = function (_insurance3) {
    _inherits(car, _insurance3);

    function car() {
        _classCallCheck(this, car);

        var _this3 = _possibleConstructorReturn(this, (car.__proto__ || Object.getPrototypeOf(car)).call(this, 'Bil', '', 'car'));

        _this3.regNumber = "";
        _this3.bonus = "";
        _this3.yearlyMileage = "";
        _this3.youngDriver = "";
        _this3.coverage = "";
        _this3.rental = "";
        _this3.engineDamage = "";
        return _this3;
    }

    return car;
}(insurance);

var animal = function (_insurance4) {
    _inherits(animal, _insurance4);

    function animal() {
        _classCallCheck(this, animal);

        var _this4 = _possibleConstructorReturn(this, (animal.__proto__ || Object.getPrototypeOf(animal)).call(this, 'Dyr', '', 'animal'));

        _this4.animalName = "";
        _this4.type = "";
        _this4.race = "";
        _this4.dateOfBirth = "";
        _this4.yearlyCoverage = "";
        _this4.coverage = "";
        _this4.lifeInsurance = false;
        _this4.lifeInsuranceSum = "";
        return _this4;
    }

    return animal;
}(insurance);

var contents = function (_insurance5) {
    _inherits(contents, _insurance5);

    function contents() {
        _classCallCheck(this, contents);

        var _this5 = _possibleConstructorReturn(this, (contents.__proto__ || Object.getPrototypeOf(contents)).call(this, 'Innbo', '', 'contents'));

        _this5.address = "";
        _this5.coverage = "";
        return _this5;
    }

    return contents;
}(insurance);

var house = function (_insurance6) {
    _inherits(house, _insurance6);

    function house() {
        _classCallCheck(this, house);

        var _this6 = _possibleConstructorReturn(this, (house.__proto__ || Object.getPrototypeOf(house)).call(this, 'Hus', '', 'house'));

        _this6.address = "";
        _this6.usageArea = "";
        _this6.usageAreaAdditional = [{
            id: _this6.generateId(),
            area: ""
        }];
        _this6.requestedCoverage = "";
        return _this6;
    }

    _createClass(house, [{
        key: 'generateId',
        value: function generateId() {
            // generate random id
            return Math.random().toString(36).substring(2, 9);
        }
    }]);

    return house;
}(insurance);

var boat = function (_insurance7) {
    _inherits(boat, _insurance7);

    function boat() {
        _classCallCheck(this, boat);

        var _this7 = _possibleConstructorReturn(this, (boat.__proto__ || Object.getPrototypeOf(boat)).call(this, 'Båt', '', 'boat'));

        _this7.type = "";
        _this7.otherType = "";
        _this7.make = "";
        _this7.constructionYear = "";
        _this7.boatZipCode = "";
        _this7.length = "";
        _this7.engineCount = "";
        _this7.engineMake = "";
        _this7.powerPerEngine = "";
        _this7.constructionYearEngine = "";
        _this7.coverageSum = "";
        _this7.groundedInWinter = false;
        _this7.securemark = false;
        _this7.registeredInSmallBoatRegister = false;
        _this7.yearsAsBoatOwner = "";
        return _this7;
    }

    return boat;
}(insurance);

var life = function (_insurance8) {
    _inherits(life, _insurance8);

    function life() {
        _classCallCheck(this, life);

        var _this8 = _possibleConstructorReturn(this, (life.__proto__ || Object.getPrototypeOf(life)).call(this, 'Personforsikring', '', 'life'));

        _this8.people = [{
            id: _this8.generateId(),
            name: "",
            idNumber: ""
        }];
        _this8.lifeInsurance = false;
        _this8.disabilityInsurance = false;
        _this8.criticalAilments = false;
        _this8.accidentInsurance = false;
        _this8.treatmentInsurance = false;
        _this8.childInsurance = false;
        return _this8;
    }

    _createClass(life, [{
        key: 'generateId',
        value: function generateId() {
            // generate random id
            return Math.random().toString(36).substring(2, 9);
        }
    }]);

    return life;
}(insurance);

var oldCar = function (_insurance9) {
    _inherits(oldCar, _insurance9);

    function oldCar() {
        _classCallCheck(this, oldCar);

        var _this9 = _possibleConstructorReturn(this, (oldCar.__proto__ || Object.getPrototypeOf(oldCar)).call(this, 'Veterankjøretøy', '', 'oldCar'));

        _this9.regNumber = "";
        _this9.constructionYear = "";
        _this9.make = "";
        _this9.model = "";
        _this9.milage = "";
        _this9.coverage = "";
        return _this9;
    }

    return oldCar;
}(insurance);

var oldMc = function (_insurance10) {
    _inherits(oldMc, _insurance10);

    function oldMc() {
        _classCallCheck(this, oldMc);

        var _this10 = _possibleConstructorReturn(this, (oldMc.__proto__ || Object.getPrototypeOf(oldMc)).call(this, 'Veteran MC', '', 'oldMc'));

        _this10.regNumber = "";
        _this10.constructionYear = "";
        _this10.make = "";
        _this10.model = "";
        _this10.milage = "";
        _this10.coverage = "";
        return _this10;
    }

    return oldMc;
}(insurance);

var specialCar = function (_insurance11) {
    _inherits(specialCar, _insurance11);

    function specialCar() {
        _classCallCheck(this, specialCar);

        var _this11 = _possibleConstructorReturn(this, (specialCar.__proto__ || Object.getPrototypeOf(specialCar)).call(this, 'Veteran- og entusiastkjøretøy', '', 'specialCar'));

        _this11.regNumber = "";
        _this11.constructionYear = "";
        _this11.make = "";
        _this11.model = "";
        _this11.milage = "";
        _this11.coverage = "";
        _this11.marketValue = "";
        _this11.yearlyMileage = "";
        _this11.driverUnder23 = "";
        _this11.deductible = "";
        _this11.dekning = "";
        _this11.longDriveInsurance = false;
        _this11.kasko = false;
        _this11.superCoverage = false;
        _this11.engineAndShiftInsurance = false;
        return _this11;
    }

    return specialCar;
}(insurance);

var travel = function (_insurance12) {
    _inherits(travel, _insurance12);

    function travel() {
        _classCallCheck(this, travel);

        var _this12 = _possibleConstructorReturn(this, (travel.__proto__ || Object.getPrototypeOf(travel)).call(this, 'Reiseforsikring', '', 'travel'));

        _this12.type = "";
        _this12.travelPeriod = "";
        _this12.travelRegion = "";
        _this12.coverage = "";
        return _this12;
    }

    return travel;
}(insurance);

var valuables = function (_insurance13) {
    _inherits(valuables, _insurance13);

    function valuables() {
        _classCallCheck(this, valuables);

        var _this13 = _possibleConstructorReturn(this, (valuables.__proto__ || Object.getPrototypeOf(valuables)).call(this, 'Verdisak', '', 'valuables'));

        _this13.value = "";
        _this13.items = "";
        return _this13;
    }

    return valuables;
}(insurance);

var userInfo = function userInfo(name, phone, email) {
    _classCallCheck(this, userInfo);

    this.name = name;
    this.phone = phone;
    this.email = email;
};

var industrialEquipment = function (_insurance14) {
    _inherits(industrialEquipment, _insurance14);

    function industrialEquipment() {
        _classCallCheck(this, industrialEquipment);

        var _this14 = _possibleConstructorReturn(this, (industrialEquipment.__proto__ || Object.getPrototypeOf(industrialEquipment)).call(this, 'Traktor og andre arbeidsmaskiner', '', 'industrialEquipment'));

        _this14.registrationNumber = "";
        _this14.machineType = "";
        return _this14;
    }

    return industrialEquipment;
}(insurance);